var map = {
	"./11.png": "4433",
	"./12.png": "4b8f",
	"./13.png": "4816",
	"./14.png": "96b6",
	"./8b8f26800c89fcbf8b97e4dde643312e.png": "0b60",
	"./akkoMain.png": "8133",
	"./amakabim.png": "255f",
	"./backToGame.png": "5545",
	"./bgGreen.png": "25c6",
	"./circle.png": "e4d1",
	"./clock.png": "eba3",
	"./disgusted.png": "2b5a",
	"./education.png": "e7ba",
	"./einDorNahalTavor.png": "3f02",
	"./enthusiastic.png": "f3d5",
	"./escalade.png": "4e1e",
	"./gps.png": "8baf",
	"./hanuka2026.png": "fbac",
	"./icons/android-chrome-192x192.png": "a1eb",
	"./icons/android-chrome-512x512.png": "3435",
	"./icons/apple-touch-icon-120x120.png": "0264",
	"./icons/apple-touch-icon-152x152.png": "e97a",
	"./icons/apple-touch-icon-180x180.png": "1a69",
	"./icons/apple-touch-icon-60x60.png": "0ed4",
	"./icons/apple-touch-icon-76x76.png": "285c",
	"./icons/apple-touch-icon.png": "1b66",
	"./icons/favicon-16x16.png": "3f32",
	"./icons/favicon-32x32.png": "d27e",
	"./icons/msapplication-icon-144x144.png": "63bf",
	"./icons/mstile-150x150.png": "fa33",
	"./jumelle.png": "dc2c",
	"./kadoorieMain.png": "7cdf",
	"./logoEDM.png": "2114",
	"./logoEifoanyBlue.png": "d0fd",
	"./logoEifoanyWhite.png": "fee3",
	"./logoGazit.png": "cb32",
	"./logorn.png": "edd2",
	"./mainGazit.png": "84ec",
	"./map.png": "c8a0",
	"./map2.png": "c312",
	"./mapBackground.png": "ee04",
	"./mapWelcomePage.png": "f7c3",
	"./menu.png": "b75d",
	"./merhavia.png": "36f6",
	"./missingWord.png": "7e8d",
	"./mitspeilan.png": "1baa",
	"./mots.png": "4b4f",
	"./navigationIcon.png": "7de4",
	"./number.png": "9b04",
	"./omer2.png": "d662",
	"./panneau.png": "9bbb",
	"./parkTavor.png": "b39e",
	"./party.png": "cdcb",
	"./people.png": "2e9e",
	"./pessahFlyer.png": "6ff6",
	"./proud.png": "7964",
	"./quartier.png": "4c6a",
	"./semel.png": "adf6",
	"./shnatMitsva.png": "fa97",
	"./skipPoint.png": "8424",
	"./smile.png": "4a19",
	"./starEnd.png": "a010",
	"./step.png": "95b3",
	"./thinking.png": "f14d",
	"./trophy.png": "5a9c",
	"./tuto/checkButton.png": "1bbc",
	"./tuto/image.png": "dbbe",
	"./tuto/main.png": "7cff",
	"./tuto/main1.png": "00ca",
	"./tuto/map.png": "edae",
	"./tuto/map3.png": "f842",
	"./tuto/mapWelcomePage.png": "80fd",
	"./tuto/missingWord.png": "92f3",
	"./tuto/number1.png": "4ebb",
	"./tuto/number2.png": "d405",
	"./tuto/panneau2.png": "4fef",
	"./tuto/picNumber.png": "a48b",
	"./tuto/points.png": "ab60",
	"./tuto/skipPoint.png": "3a11",
	"./tuto/tuto1.png": "d28c",
	"./tuto/tuto2.png": "c017",
	"./tuto/tuto3.png": "3de7",
	"./tuto/tuto4.png": "a045",
	"./tuto/tuto5.png": "16eb",
	"./waze.png": "fddf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2840";